"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeStatements = void 0;
var properties_maker_1 = require("../util/properties-maker");
// TODO: achil change to singular
var NodeStatements = /** @class */ (function () {
    function NodeStatements(arg) {
        this.nodeId = arg.nodeId;
        this.statements = arg.statements;
    }
    NodeStatements.buildFrom = function (src, props) {
        return new NodeStatements(properties_maker_1.PropertiesMaker.merge(src, props));
    };
    return NodeStatements;
}());
exports.NodeStatements = NodeStatements;
